enum ONPeriodicEnum {
  CATEGORY_NAME = 0,
  SKU = 1,
  BARCODE = 2,
  UNIT_OF_MEASURE = 3,
}

export class ONPeriodicReport {
  categoryName: string
  sku: string
  barcode: string
  unitOfMeasure: number | string

  constructor(report: string[]) {
    this.categoryName = report[ONPeriodicEnum.CATEGORY_NAME]
    this.sku = report[ONPeriodicEnum.SKU]
    this.barcode = report[ONPeriodicEnum.BARCODE]
    this.unitOfMeasure =
      parseFloat(report[ONPeriodicEnum.UNIT_OF_MEASURE]) || report[ONPeriodicEnum.UNIT_OF_MEASURE]
  }
}

enum ONInventoryAdjustments {
  CATEGORY_NAME = 0,
  SKU = 1,
  BARCODE = 2,
  UNIT_OF_MEASURE = 3,
  DATE = 4,
  BOOK_BALANCE = 5,
  COUNT_BALANCE = 6,
  DISCREPANCY_TYPE = 8,
  NOTE = 9,
}
export class ONInventoryAdjustmentsReport extends ONPeriodicReport {
  date: Date | string
  bookBalance: number | string
  countBalance: number | string
  difference: number | string
  discrepancyType: string
  note: string

  constructor(report: string[]) {
    super(report)
    this.date = report[ONInventoryAdjustments.DATE]
    this.bookBalance =
      report[ONInventoryAdjustments.BOOK_BALANCE] === ''
        ? report[ONInventoryAdjustments.BOOK_BALANCE]
        : parseInt(report[ONInventoryAdjustments.BOOK_BALANCE])
    this.countBalance =
      report[ONInventoryAdjustments.COUNT_BALANCE] === ''
        ? report[ONInventoryAdjustments.COUNT_BALANCE]
        : parseInt(report[ONInventoryAdjustments.COUNT_BALANCE])
    this.difference =
      Number.isNaN(this.countBalance) || Number.isNaN(this.bookBalance)
        ? ''
        : Number(this.countBalance) - Number(this.bookBalance)
    this.discrepancyType = report[ONInventoryAdjustments.DISCREPANCY_TYPE]
    this.note = report[ONInventoryAdjustments.NOTE]
  }
}

enum ONDestructions {
  CATEGORY_NAME = 0,
  SKU = 1,
  BARCODE = 2,
  UNIT_OF_MEASURE = 3,
  INCIDENT_NUMBER = 4,
  QUANTITY_DESTROYED = 5,
  SENSORY_DISPLAY_QTY = 6,
  DATE = 7,
  TIME_OF_DESTRUCTION = 8,
  APPEARED_PRIOR_PERIOD = 9,
  METHOD_OF_DESTRUCTION = 10,
  USER = 11,
  NOTE = 12,
}

export class ONDestructionsReport extends ONPeriodicReport {
  incidentNumber: string
  quantityDestroyed: number | string
  sensoryDisplayQty: string
  date: Date | string
  timeOfDestruction: string
  appearedPriorPeriod: string
  methodOfDestruction: string
  userName: string
  note: string

  constructor(report: string[]) {
    super(report)
    this.incidentNumber = report[ONDestructions.INCIDENT_NUMBER]
    this.quantityDestroyed =
      report[ONDestructions.QUANTITY_DESTROYED] === ''
        ? report[ONDestructions.QUANTITY_DESTROYED]
        : parseInt(report[ONDestructions.QUANTITY_DESTROYED])
    this.sensoryDisplayQty = report[ONDestructions.SENSORY_DISPLAY_QTY]
    this.date = report[ONDestructions.DATE]
    this.timeOfDestruction = report[ONDestructions.TIME_OF_DESTRUCTION]
    this.appearedPriorPeriod = report[ONDestructions.APPEARED_PRIOR_PERIOD]
    this.methodOfDestruction = report[ONDestructions.METHOD_OF_DESTRUCTION]
    this.userName = report[ONDestructions.USER]
    this.note = report[ONDestructions.NOTE]
  }
}

enum ONTransfers {
  CATEGORY_NAME = 0,
  SKU = 1,
  BARCODE = 2,
  UNIT_OF_MEASURE = 3,
  TRANSFER_QUANTITY = 4,
  DATE = 5,
  USER = 6,
  CRSA = 7,
  RECIEVED_BY = 8,
}

export class ONTransfersReport extends ONPeriodicReport {
  transferQuantity: number | string
  createDate: Date | string
  userName: string
  crsa: string
  recievedBy: string

  constructor(report: string[]) {
    super(report)
    this.transferQuantity =
      report[ONTransfers.TRANSFER_QUANTITY] === ''
        ? report[ONTransfers.TRANSFER_QUANTITY]
        : parseInt(report[ONTransfers.TRANSFER_QUANTITY])
    this.createDate = report[ONTransfers.DATE]
    this.userName = report[ONTransfers.USER]
    this.crsa = report[ONTransfers.CRSA]
    this.recievedBy = report[ONTransfers.RECIEVED_BY]
  }
}
